<template>
  <v-card elevation="0" class="all-trade-tab rounded-0 mt-5" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs v-model="model" background-color="transparent">
      <v-tab :href="`#tab-1`">
        Waiting to Start
      </v-tab>
      <v-tab :href="`#tab-2`">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Running Contest
      </v-tab>
      <v-tab :href="`#tab-3`">
        Finished Contest
      </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card class="mt-0" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <pending-join-request :allupcomingparticipants="allupcomingparticipants"></pending-join-request>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card class="mt-0" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <running-join-request :allrunningparticipants="allrunningparticipants"></running-join-request>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <v-card class="mt-0" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <finished-join-request :allfinishedparticipants="allfinishedparticipants"></finished-join-request>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>
import FinishedJoinRequest from './FinishedJoinRequest.vue';
import PendingJoinRequest from './PendingJoinRequest.vue';
import RunningJoinRequest from './RunningJoinRequest.vue';

import { CONTEST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    PendingJoinRequest,
    RunningJoinRequest,
    FinishedJoinRequest
  },

  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },

  computed: {
    ...mapState("contest", ["allfinishedparticipants", "allrunningparticipants", "allupcomingparticipants"]),
  },
  methods: {
    ...mapActions("contest", [
      CONTEST__ACTIONS.ALLFINISHEDPARTICIPANTS,
      CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS,
      CONTEST__ACTIONS.ALLUPCOMINGPARTICIPANTS,
    ]),
  },
  async mounted() {
    await this[CONTEST__ACTIONS.ALLFINISHEDPARTICIPANTS]();
    await this[CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS]();
    await this[CONTEST__ACTIONS.ALLUPCOMINGPARTICIPANTS]();
  }
};
</script>
